import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const InstagramSection = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  // Inject responsive styles
  useEffect(() => {
    const styleId = 'instagram-section-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .instagram-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 10px;
          position: relative;
        }
        
        .instagram-grid-item:nth-child(4) {
          display: block;
        }
        
        @media (max-width: 768px) {
          .instagram-grid {
            grid-template-columns: repeat(3, 1fr);
          }
          
          .instagram-grid-item:nth-child(4) {
            display: none;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  // Fetch images from Supabase
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const { data, error } = await supabase
          .from('site_images')
          .select('*')
          .eq('section', 'instagram')
          .order('created_at', { ascending: true })
          .limit(4);

        if (error) throw error;
        setImages(data);
      } catch (error) {
        console.error('Error fetching Instagram images:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  if (loading) {
    return (
      <section style={{
        height: '200px',
        backgroundColor: '#0A0A0A',
      }} />
    );
  }

  return (
    <section style={{
      backgroundColor: '#0A0A0A',
      padding: '10px',
    }}>
      <div className="instagram-grid">
        {images.map((image, index) => (
          <div
            key={image.id}
            className="instagram-grid-item"
            style={{
              aspectRatio: '1 / 1',
              overflow: 'hidden',
            }}
          >
            <img
              src={image.image_url}
              alt={image.name || 'Instagram image'}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </div>
        ))}

        {/* Centered Instagram Button */}
        <a
          href="https://www.instagram.com/rtk.artistry"
          target="_blank"
          rel="noopener noreferrer"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'inline-block',
            backgroundColor: isHovered ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.15)',
            backdropFilter: 'blur(8px)',
            border: 'none',
            padding: '12px 24px',
            color: '#F1F1F1',
            fontSize: '16px',
            lineHeight: 'normal',
            fontWeight: '400',
            fontFamily: "'TASA Orbiter Display', sans-serif",
            textDecoration: 'none',
            letterSpacing: '0.01em',
            transition: 'background-color 0.3s ease',
            cursor: 'pointer',
            WebkitTextSizeAdjust: 'none',
            WebkitAppearance: 'none',
          }}
        >
          Follow @rtk.artistry
        </a>
      </div>
    </section>
  );
};

export default InstagramSection;